import axios from 'axios';
import { useUserStore } from '@/v2/application/stores/userStore';

// Crear instancia de axios
const apiClient = axios.create({
  baseURL: '/', // Cambiar si tienes una URL base específica
  timeout: 10000,
});


// Interceptor para agregar el header x-auth-token
apiClient.interceptors.request.use(
  config => {
    const userStore = useUserStore();
    const token = userStore.getToken()//localStorage.getItem('auth-token'); // O donde guardes el token
    if (token) {
      config.headers['x-auth-token'] = token;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Interceptor para manejo global de errores
apiClient.interceptors.response.use(
  response => response,
  error => {
    if (error.response) {
      // Puedes manejar errores específicos aquí
      console.error('Error en la respuesta:', error.response.status, error.response.data);
      // Ejemplo: si es 401, redirigir a login
      if (error.response.status === 401) {
        // window.location.href = '/login';
        console.warn('No autorizado, redirigiendo a login...');
      }
    } else if (error.request) {
      console.error('No se recibió respuesta del servidor');
    } else {
      console.error('Error en la configuración de la petición', error.message);
    }
    return Promise.reject(error);
  }
);

export default apiClient;
